const styles = {
	defaultStyle: {
		container: () => ({
			position: 'relative',
			width: '100%',
		}),
		control: (base, state) => ({
			alignItems: 'center',
			borderRadius: '3px',
			cursor: state.isDisabled ? 'default' : 'pointer',
			display: 'flex',
			justifyContent: 'space-between',
			padding: '.2rem .6rem',
			transition: 'background .2s cubic-bezier(.645, .045, .355, 1)',
			'.theme--light &:hover': {
				background: state.isDisabled ? 'transparent' : '#F5F5F5',
			},
			'.theme--dark &:hover': {
				background: state.isDisabled ? 'transparent' : '#333333',
			},
		}),
		valueContainer: () => ({
			alignItems: 'stretch',
			display: 'flex',
			flex: 1,
			flexWrap: 'wrap',
			fontSize: 'inherit',
			justifyContent: 'stretch',
			overflow: 'hidden',
			position: 'relative',
		}),
		singleValue: (base, state) => ({
			label: 'singleValue',
			maxWidth: '100%',
			opacity: state.isDisabled ? 0.5 : 1,
			overflow: 'hidden',
			position: 'absolute',
			textOverflow: 'ellipsis',
			top: '50%',
			transform: 'translateY(-50%)',
			whiteSpace: 'nowrap',
		}),
		input: state => ({
			color: 'inherit',
			visibility: state.isDisabled ? 'hidden' : 'visible',
		}),
		indicatorsContainer: () => ({
			color: '#BFBFBF',
		}),
		indicatorSeparator: () => ({
			display: 'none',
		}),
		menu: () => ({
			borderRadius: '6px',
			boxShadow:
				'2px 2px 4px 0 rgba(77,77,77,0.05), 0 4px 20px 0 rgba(77,77,77,0.10)',
			color: '#949494',
			fontSize: '.7rem',
			marginTop: '.6rem',
			padding: '.6rem',
			position: 'absolute',
			right: 0,
			width: '15rem',
			zIndex: 99999,
			'.theme--light &': {
				background: '#ffffff',
			},
			'.theme--dark &': {
				background: '#333333',
			},
		}),
		menuList: () => ({
			maxHeight: '15rem',
			overflowY: 'auto',
			position: 'relative',
			WebkitOverflowScrolling: 'touch',
			'.theme--light &': {
				scrollbarColor: '#EAEAEA transparent',
			},
			'.theme--dark &': {
				scrollbarColor: '#262523 transparent',
			},
			'&::-webkit-scrollbar': {
				height: '4.75rem',
				width: '.75rem',
			},
			'&::-webkit-scrollbar-button': {
				display: 'none',
				width: 0,
				height: 0,
			},
			'&::-webkit-scrollbar-corner': {
				backgroundColor: 'transparent',
			},
			'.theme--light &::-webkit-scrollbar-thumb': {
				backgroundColor: '#EAEAEA',
			},
			'.theme--dark &::-webkit-scrollbar-thumb': {
				backgroundColor: '#262523',
			},
			'&::-webkit-scrollbar-track, &::-webkit-scrollbar-thumb': {
				backgroundClip: 'padding-box',
				border: '4px solid transparent',
				borderRadius: '8px',
			},
			'&::-webkit-scrollbar-track': {
				backgroundColor: 'transparent',
			},
		}),
		menuPortal: base => ({
			...base,
			zIndex: 99999999999,
		}),
	},
	alternativeStyle: {
		group: (base, state) => ({
			margin: 0,
			marginBottom: '1rem',
			'&:last-child': {
				marginBottom: '0',
			},
		}),
		groupHeading: (base, state) => ({
			marginBottom: '0.6rem',
			marginLeft: '0.6rem',
		}),
		control: (base, state) => ({
			...styles.defaultStyle.control(base, state),
			'.theme--light &, .theme--light &:hover': {
				background: state.isDisabled ? 'transparent' : '#fff',
			},
			'.theme--dark &, .theme--dark &:hover': {
				background: state.isDisabled ? 'transparent' : '#333333',
			},
		}),
	},
}

export default styles
